import { createStore } from 'redux';
import rootReducers from './reducers';

export default createStore(rootReducers);